import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberAchievements } from "./routeType";

const { key, getPath } = getApi("members.achievements.getAll");

type IExtractedRouteType = IMemberAchievements["achievementCollectionRetrieve"];

export type IGetAllMemberAchievements =
  IPickCollectionQuery<IExtractedRouteType>;

const getAllMemberAchievements: Fetcher<
  IGetAllMemberAchievements["response"],
  IGetAllMemberAchievements["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetAllMemberAchievements = createQuery({
  queryKey: [key],
  fetcher: getAllMemberAchievements,
});
